export const itinerary_details_events = {
  itinerary_details_back_click: {
    category: "User navigates back to Itinerary listing page",
    action: "User clicks on back button",
    label: "itinerary-details-back-click",
  },
  itinerary_details_save_click: {
    category: "Save itinerary popup will open",
    action: "User clicks on save button",
    label: "itinerary-details-save-click",
  },
  itinerary_details_save_name_input: {
    category: "Save itinerary popup",
    action: "User clicks on name input",
    label: "itinerary-details-save-name-input",
  },
  itinerary_details_save_itinerary_click: {
    category: "Users is saving trip ",
    action: "User clicks on save itinerary button",
    label: "itinerary-details-save-itinerary-click",
  },
  itinerary_details_save_itinerary_Xclose_click: {
    category: "Allows user to close the popup",
    action: "User clicks on x close button",
    label: "itinerary-details-save-close-click",
  },
  itinerary_details_share_click: {
    category: "Allows user to share the itinerary",
    action: "User clicks on share button",
    label: "itinerary-details-share-click",
  },
  itinerary_details_header_book_click: {
    category: "Itinerary details booking",
    action: "User clicks book from itinerary details header",
    label: "itinerary-details-header-book-click",
  },
  itinerary_details_footer_book_click: {
    category: "Itinerary details booking",
    action: "User clicks book from itinerary details footer",
    label: "itinerary-details-book-click",
  },

  itinerary_details_book_only_flight_click: {
    category: "User navigates to booking page",
    action: "User clicks on book flight button",
    label: "itinerary-details-book-flights-click",
  },

  itinerary_details_book_only_hotel_click: {
    category: "User navigates to booking page",
    action: "User clicks on book hotel button",
    label: "itinerary-details-book-stays-click",
  },

  itinerary_details_modify_activities_click: {
    category: "User can modify the activity",
    action: "User clicks on modify icon",
    label: "itinerary-details-modify-activity-click",
  },

  itinerary_details_activities_done_click: {
    category: "User can update the modified activity",
    action: "User clicks on done icon",
    label: "itinerary-details-save-changes-click",
  },

  itinerary_details_refine_click: {
    category: "User can refine the itinerary",
    action: "User clicks on refine button",
    label: "itinerary-details-refine-click",
  },

  itinerary_details_view_activity_details: {
    category: "User checking activity details",
    action: "User clicks blue hyperlink of activity",
    label: "itinerary-details-activity-view-click",
  },
  itinerary_details_close_activity_details: {
    category: "User checking activity details",
    action: "User clicks blue hyperlink of activity",
    label: "itinerary-details-activity-close-click",
  },
  itinerary_details_image_select_click: {
    category: "Itinerary details interaction",
    action: "User selects a thumbnail to change the slideshow image",
    label: "itinerary-details-image-select-click",
  },
  itinerary_day_details_click: {
    category: "Itinerary details interaction",
    action: "User clicks on open activity details accordion heading",
    label: "itinerary-details-day-open-click",
  },
  itinerary_day_details_click_close: {
    category: "Itinerary details interaction",
    action: "User clicks on close activity details accordion heading",
    label: "itinerary-details-day-close-click",
  },
  itinerary_details_edit_daily_details_input_click: {
    category: "Itinerary details interaction",
    action: "User clicks input to edit daily details",
    label: "itinerary-details-edit-activities-click",
  },
  itinerary_details_edit_daily_details_input_clear_click: {
    category: "Itinerary details interaction",
    action: "User clicks on clear input to edit daily details",
    label: "itinerary-details-edit-activities-clear",
  },
  itinerary_details_edit_close: {
    category: "Itinerary details interaction",
    action: "User clicks on close button in edit daily details modal",
    label: "itinerary-details-edit-close-click",
  },
  viewItinerary: {
    category: "User views itinerary",
    action: "When the user views the itinerary",
    label: "viewItinerary",
  },
  payment_pay_failure: {
    category: "Payment failure",
    action: "When Payment got failed",
    label: "payment-pay-failure",
  },
};
